/**
 * The app's theme root (TMMPDM-0039): one theme with Light and Dark schemes, the mode persisted
 * under the sanctioned key, System (the OS setting) on a first visit. `noSsr` resolves the saved
 * mode in the first render, so the scheme class is on <html> before the first paint; switching
 * suppresses CSS transitions (A11Y-009).
 */
import { useMemo, type ReactNode } from 'react';
import { ThemeProvider } from '@mui/material';
import { createAppTheme } from './theme';
import { COLOR_SCHEME_MODE_KEY, COLOR_SCHEME_RESOLVED_KEY } from './colorScheme';

export function AppThemeProvider({ children }: { children: ReactNode }) {
  const theme = useMemo(() => createAppTheme(), []);
  return (
    <ThemeProvider
      theme={theme}
      defaultMode="system"
      modeStorageKey={COLOR_SCHEME_MODE_KEY}
      colorSchemeStorageKey={COLOR_SCHEME_RESOLVED_KEY}
      noSsr
      disableTransitionOnChange
    >
      {children}
    </ThemeProvider>
  );
}
